"use client";
import React from "react";
import { motion } from "framer-motion";

interface Testimonial {
  text: string;
  image: string;
  name: string;
  role: string;
}

export const TestimonialsColumn = (props: {
  className?: string;
  testimonials: Testimonial[];
  duration?: number;
}) => {
  return (
    <div className={props.className}>
      <motion.div
        animate={{
          translateY: "-50%",
        }}
        transition={{
          duration: props.duration || 10,
          repeat: Infinity,
          ease: "linear",
          repeatType: "loop",
        }}
        className="flex flex-col gap-6 pb-6"
      >
        {[
          ...new Array(2).fill(0).map((_, index) => (
            <React.Fragment key={index}>
              {props.testimonials.map(({ text, image, name, role }, i) => (
                <div className="p-6 rounded-2xl border border-modular-stone-alloy/30 dark:border-modular-stone-alloy/20 
                  shadow-lg shadow-modular-frosted-indigo/10 dark:shadow-modular-frosted-indigo/20 max-w-xs w-full 
                  bg-white/95 dark:bg-dark-surface/95 backdrop-blur-sm
                  hover:shadow-modular-card dark:hover:shadow-dark-fire transition-all duration-300" key={i}>
                  <div className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed mb-4">
                    "{text}"
                  </div>
                  <div className="flex items-center gap-3">
                    <img
                      width={40}
                      height={40}
                      src={image}
                      alt={name}
                      className="h-10 w-10 rounded-full border-2 border-modular-frosted-indigo dark:border-modular-frosted-indigo"
                    />
                    <div className="flex flex-col">
                      <div className="font-semibold tracking-tight leading-5 text-gray-900 dark:text-dark-text">
                        {name}
                      </div>
                      <div className="leading-5 text-modular-frosted-indigo dark:text-modular-frosted-indigo tracking-tight text-sm font-medium">
                        {role}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </React.Fragment>
          )),
        ]}
      </motion.div>
    </div>
  );
};